import type { AnchorHTMLAttributes, ButtonHTMLAttributes, FC, ReactNode } from "react";

import classnames from "classnames";

import type { DirectionalIconComponent } from "@jti/brand-icons";
import { Icon } from "@jti/core-components/components/Icon";
import { LinkBehaviour } from "@jti/core-components/components/LinkBehaviour";

import styles from "./HeaderDesktopNavItem.module.scss";

export type HeaderDesktopNavItemProps = {
  label: string;
  href: string;
  badge?: ReactNode;
  hasSecondaryNavigation?: boolean;
  isOpen?: boolean;
  chevronIcon?: DirectionalIconComponent;
  onChevronClick?: ButtonHTMLAttributes<HTMLButtonElement>["onClick"];
  chevronAriaLabel?: string;
} & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "children">;

export const HeaderDesktopNavItem: FC<HeaderDesktopNavItemProps> = ({
  label,
  href,
  badge,
  hasSecondaryNavigation = false,
  isOpen = false,
  chevronIcon,
  onChevronClick,
  chevronAriaLabel,
  className,
  ...linkProps
}) => (
  <span className={classnames(styles.wrapper, className)}>
    <LinkBehaviour
      href={href}
      className={classnames(styles.headerDesktopNavItem, {
        [styles.headerDesktopNavItemWithChevron]: hasSecondaryNavigation && chevronIcon,
      })}
      {...linkProps}
    >
      <span className={styles.label}>{label}</span>
      {badge}
    </LinkBehaviour>
    {hasSecondaryNavigation && chevronIcon && (
      <button
        type="button"
        className={styles.chevronButton}
        onClick={onChevronClick}
        aria-expanded={isOpen}
        aria-label={chevronAriaLabel}
      >
        <Icon
          icon={chevronIcon}
          size="xs"
          className={classnames(styles.chevron, isOpen && styles.chevronOpen)}
          aria-hidden
        />
      </button>
    )}
  </span>
);
